import { showNaturalColor, zoomTo } from "../../api/layers";
import { setFootprintGraphics, removeLayers } from "../../api/graphics";
import { findIdFor } from "../helpers";
import { sortWith, ascend, descend, prop } from "ramda";
import { center } from "../map/map.helpers";

export const toggleVisibility = ({ view, ids, imagery }) => {
  view.map.layers.items
    .filter((l) => l.type === "imagery" && l.title !== imagery.title)
    .forEach((layer) => {
      layer.visible = ids.includes(findIdFor(layer));
    });
};

export const zoomToLayer = ({ enabled, view, imagery, layerId }) => {
  view.goTo({ target: center, zoom: 6 });
  if (enabled) {
    view.map.layers.forEach((layer) => {
      if (layer.type === "imagery" && layerId === findIdFor(layer)) {
        zoomTo({ view, layerId, imagery });
      }
    });
  }
};

export const setLayerVisibility = ({ view, imagery, ids }) => {
  if (view && imagery) toggleVisibility({ view, ids, imageryLayer: imagery });
};

export const setLayerFootprints = ({ ids, imagery, view, outFields, appName }) => {
  if (ids && ids.length && view && imagery) {
    setFootprintGraphics({ view, ids, imagery, outFields, appName });
  } else if (view) removeLayers({ view });
};

export const setLayerNaturalColored = ({ view, imagery, ids }) => {
  if (view && imagery) showNaturalColor({ view, ids, imageryLayer: imagery });
};

export const sortLayers = (layers) => {
  const layerSorter = sortWith([ascend(prop("disabled")), ascend(prop("id"))]);
  return layerSorter(layers);
};
